<script>
export default {
  props: {
    latestChatwootVersion: { type: String, default: '' },
  },
};
</script>

<template>
  <div />
</template>
